import ReactDOM from 'react-dom/client';
import { App } from './App';

import '@caju-beneficios/sponsor-v2-lib/dist/index.css';
import '@caju-beneficios/react-web-commons/dist/index.css';

import './sv2.config';

import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
